'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactLoader = require('react-loader');

var _reactLoader2 = _interopRequireDefault(_reactLoader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var spinnerOpts = {
  lines: 8,
  length: 1,
  width: 14,
  radius: 32,
  scale: 1,
  corners: 3,
  color: '#2379BF',
  opacity: 0.25,
  rotate: 0,
  direction: 1,
  speed: 1,
  trail: 60,
  fps: 20,
  zIndex: 2e9,
  className: 'spinner',
  top: '300px',
  left: '50%',
  shadow: false,
  hwaccel: false,
  height: '300px'
};

var LoadingIndicator = function LoadingIndicator(_ref) {
  var isLoaded = _ref.isLoaded,
      children = _ref.children;

  return _react2.default.createElement(
    _reactLoader2.default,
    {
      loaded: isLoaded,
      options: spinnerOpts
    },
    children
  );
};

LoadingIndicator.propTypes = {
  isLoaded: _propTypes2.default.bool.isRequired,
  children: _propTypes2.default.any
};

exports.default = LoadingIndicator;


//////////////////
// WEBPACK FOOTER
// ./lib/shared/LoadingIndicator.js
// module id = 201
// module chunks = 0